export default __webpack_public_path__ + "static/media/Teri_9781408355206.f29c540f.jpg";